import {emptySplitApi, providesTagsList, queryStarted} from "./api";

export const samApi = emptySplitApi.injectEndpoints({
    endpoints: (builder) => ({
        listSAMMeetings: builder.query({
            query: () => ({
                url: 'sam/meeting/list',
                method: 'GET'
            }),
            providesTags: (result) => providesTagsList('SAMMeeting', result)
        }),
        getSAMMeeting: builder.query({
            query: (id) => `sam/meeting/${id}`,
            providesTags: (result, error, id) => [{ type: 'SAMMeeting', id }]
        }),
        createSAMMeeting: builder.mutation({
            query: (data) => ({
                url: 'sam/meeting/create',
                method: 'POST',
                body: data
            }),
            invalidatesTags: [{ type: 'SAMMeeting', id: 'LIST' }]
        }),
        updateSAMMeeting: builder.mutation({
            query: ({id, ...data}) => ({
                url: `sam/meeting/update/${id}`,
                method: 'PUT',
                body: data
            }),
            onQueryStarted: (args, api) => queryStarted(args, api, 'getSAMMeeting'),
            invalidatesTags: (result, error, { id }) => [{ type: 'SAMMeeting', id }]
        }),
        deleteSAMMeeting: builder.mutation({
            query: (id) => ({
                url: `sam/meeting/delete/${id}`,
                method: 'DELETE'
            }),
            invalidatesTags: [{ type: 'SAMMeeting', id: 'LIST' }, { type: 'SAMTask', id: 'LIST' }]
        }),
        updateSAMAgenda: builder.mutation({
            query: ({id, ...data}) => ({
                url: `sam/meeting/update-agenda/${id}`,
                method: 'PUT',
                body: data
            }),
            onQueryStarted: (args, api) => queryStarted(args, api, 'getSAMMeeting'),
            invalidatesTags: (result, error, { id }) => [{ type: 'SAMMeeting', id }]
        }),
        listSAMTasks: builder.query({
            query: () => ({
                url: 'sam/task/list',
                method: 'GET'
            }),
            providesTags: (result) => providesTagsList('SAMTask', result)
        }),
        getSAMTask: builder.query({
            query: (id) => `sam/task/${id}`,
            providesTags: (result, error, id) => [{ type: 'SAMTask', id }]
        }),
        createSAMTask: builder.mutation({
            query: (data) => ({
                url: 'sam/task/create',
                method: 'POST',
                body: data
            }),
            invalidatesTags: [{ type: 'SAMTask', id: 'LIST' }]
        }),
        updateSAMTask: builder.mutation({
            query: ({id, ...data}) => ({
                url: `sam/task/update/${id}`,
                method: 'PUT',
                body: data
            }),
            onQueryStarted: (args, api) => queryStarted(args, api, 'getSAMTask'),
            invalidatesTags: (result, error, { id }) => [{ type: 'SAMTask', id }]
        }),
        deleteSAMTask: builder.mutation({
            query: (id) => ({
                url: `sam/task/delete/${id}`,
                method: 'DELETE'
            }),
            invalidatesTags: [{ type: 'SAMTask', id: 'LIST' }]
        }),
        updateSAMTaskStatus: builder.mutation({
            query: ({id, ...data}) => ({
                url: `sam/task/update-status/${id}`,
                method: 'PUT',
                body: data
            }),
            onQueryStarted: (args, api) => queryStarted(args, api, 'getSAMTask'),
            invalidatesTags: (result, error, { id }) => [{ type: 'SAMTask', id }]
        }),
        updateSAMTaskValue: builder.mutation({
            query: ({id, ...data}) => ({
                url: `sam/task/update-value/${id}`,
                method: 'PUT',
                body: data
            }),
            onQueryStarted: (args, api) => queryStarted(args, api, 'getSAMTask'),
            invalidatesTags: (result, error, { id }) => [{ type: 'SAMTask', id }]
        }),
        updateSAMTaskQuestions: builder.mutation({
            query: ({id, ...data}) => ({
                url: `sam/task/update-question-list/${id}`,
                method: 'PUT',
                body: data
            }),
            onQueryStarted: (args, api) => queryStarted(args, api, 'getSAMTask'),
            invalidatesTags: (result, error, { id }) => [{ type: 'SAMTask', id }]
        })
    })
});

export const {
    useListSAMMeetingsQuery,
    useGetSAMMeetingQuery,
    useCreateSAMMeetingMutation,
    useUpdateSAMMeetingMutation,
    useDeleteSAMMeetingMutation,
    useUpdateSAMAgendaMutation,
    useListSAMTasksQuery,
    useGetSAMTaskQuery,
    useLazyGetSAMMeetingQuery,
    useCreateSAMTaskMutation,
    useUpdateSAMTaskMutation,
    useDeleteSAMTaskMutation,
    useUpdateSAMTaskStatusMutation,
    useUpdateSAMTaskValueMutation,
    useUpdateSAMTaskQuestionsMutation,
} = samApi;